// 从v2.11.2起，SDK 支持了 WebSocket，推荐接入；v2.10.2及以下版本，使用 HTTP
import TIM from 'tim-js-sdk';
import TIMUploadPlugin from 'tim-upload-plugin';
import store from "../../store"
let options = {
    SDKAppID: 1400615273 // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
};
// 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
let tim = TIM.create(options); // SDK 实例通常用 tim 表示

// 设置 SDK 日志输出级别，详细分级请参见 <a href="https://web.sdk.qcloud.com/im/doc/zh-cn//SDK.html#setLogLevel">setLogLevel 接口的说明</a>
// tim.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用

// 注册腾讯云即时通信 IM 上传插件
tim.registerPlugin({'tim-upload-plugin': TIMUploadPlugin});


let receiveMessage = (event) => {
  // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
  let message = event.data[0]
  //添加一个属性 判断是 收到的消息 还是自己发送出去的消息（store中的updateMsgList中的判断用到）
  message.sendByOtherUser=true
  store.commit('updateMsgList', message)
}

tim.on(TIM.EVENT.MESSAGE_RECEIVED, receiveMessage);

//监听好友列表发生变化
let onConversationListUpdated=(event)=>{
  store.commit('updateUserList')
}
//用户列表的监听 好友列表
tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, onConversationListUpdated);


let onSdkReady = function (event) {
};
tim.on(TIM.EVENT.SDK_READY, onSdkReady);


let kickedOut=(event) =>{
  // 收到被踢下线通知
  console.log('腾讯云收到被踢下线通知,请重新登录')
}
tim.on(TIM.EVENT.KICKED_OUT, kickedOut);


export default tim;



// WEBPACK FOOTER //
// ./src/framework/utils/chat/tim.js